import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../../icon/icon';

type Props = {
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
};

const EditIcon = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Icon
      aria-label={t('common.assetHeaderIcons.edit', { ns: 'skyviewAssetMenu' })}
      disabled={props.disabled}
      fixedWidth={true}
      icon={['fal', 'pencil']}
      mouseDownStyle={{ opacity: 0.5 }}
      stopPropagationOnClick={true}
      title={t('common.assetHeaderIcons.edit', { ns: 'skyviewAssetMenu' })}
      onClick={props.onClick}
      onHoverStyle={{ icon: ['fad', 'pencil'] }}
    />
  );
};

export { EditIcon };
